import { useState, useEffect } from 'react';
import { portalApi } from '../../api';

export default function PortalHome() {
  const [products, setProducts] = useState<any[]>([]);
  const [cart, setCart] = useState<Record<number, number>>({});
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { portalApi('/products').then(setProducts).catch(() => {}); }, []);

  const setQty = (id: number, q: number) => {
    const n = Math.max(0, Math.floor(q));
    setCart((c) => { const cc = { ...c }; if (n > 0) cc[id] = n; else delete cc[id]; return cc; });
  };

  const selected = Object.entries(cart).filter(([, q]) => q > 0);
  const total = selected.reduce((s, [id, q]) => s + q * (products.find((p) => p.id === Number(id))?.price || 0), 0);

  const submit = async () => {
    if (selected.length === 0) return alert('请先选择要报货的产品');
    setSubmitting(true); setMsg('');
    try {
      const items = selected.map(([id, q]) => ({ product_id: Number(id), quantity: q }));
      const r = await portalApi('/orders', { method: 'POST', body: JSON.stringify({ items }) });
      setCart({}); setMsg(`✅ 报货单 ${r.order_no} 已提交，等待业务员接单`);
    } catch (e: any) { alert(e.message); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="space-y-3">
      <div>
        <h2 className="text-lg font-bold text-emerald-800">🛒 产品目录</h2>
        <p className="text-xs text-slate-500">选择数量后提交报货单，业务员将尽快接单</p>
      </div>

      {msg && <div className="bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-lg p-3 text-sm">{msg}</div>}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {products.map((p) => (
          <div key={p.id} className="bg-white rounded-xl shadow-sm p-3 border border-slate-100">
            <div className="flex justify-between items-start">
              <div>
                <div className="font-medium">{p.name}</div>
                <div className="text-xs text-slate-400">{p.code} · {p.category || '—'} · {p.unit}</div>
              </div>
              <div className="text-emerald-600 font-bold text-sm">¥{Number(p.price).toLocaleString()}</div>
            </div>
            <div className="flex items-center justify-between mt-3">
              <div className="flex items-center gap-2">
                <button onClick={() => setQty(p.id, (cart[p.id] || 0) - 1)} className="w-8 h-8 rounded-full bg-slate-100 text-lg leading-none">−</button>
                <input
                  type="number"
                  min={0}
                  value={cart[p.id] || 0}
                  onChange={(e) => setQty(p.id, Number(e.target.value))}
                  className="w-14 text-center border rounded-lg py-1"
                />
                <button onClick={() => setQty(p.id, (cart[p.id] || 0) + 1)} className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 text-lg leading-none">＋</button>
              </div>
            </div>
          </div>
        ))}
        {products.length === 0 && <div className="text-slate-400 text-sm">暂无产品</div>}
      </div>

      {/* 底部提交栏 */}
      {selected.length > 0 && (
        <div className="fixed bottom-16 inset-x-0 z-20 px-4 pb-2">
          <div className="max-w-[900px] mx-auto bg-white border border-emerald-200 rounded-xl shadow-lg p-3 flex items-center justify-between">
            <div className="text-sm">
              <div className="text-slate-500">已选 {selected.length} 项</div>
              <div className="font-bold text-emerald-700">合计 ¥{total.toLocaleString()}</div>
            </div>
            <button onClick={submit} disabled={submitting} className="bg-emerald-600 text-white rounded-lg px-5 py-2 text-sm font-bold hover:bg-emerald-700 disabled:opacity-60">
              {submitting ? '提交中…' : '提交报货单'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
